import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductFamilyComponent } from './productfamily/productfamily.component';
import { OPCAdminComponent } from './opc-admin.component';
import { AdminAuthGuard } from './auth-guard-service';
import { ProductLineComponent } from './productline/productline.component';
import { PartCategoryComponent } from './partcategory/partcategory.component';
import { PartGroupComponent } from './partgroup/partgroup.component';
import { PartComponent } from './part/part.component';
import { ExportComponent } from './export/export.component';
import { ColorComponent } from './color/color.component';
import { Color } from './color/color.guard';

const appRoutes: Routes = [
    {
        path: 'manage',
        component: OPCAdminComponent,
        canActivate: [AdminAuthGuard],
        children: [
            {
                path: '',
                component: ProductFamilyComponent
            },
            {
                path: 'productfamily',
                component: ProductFamilyComponent

            },
            {
                path: 'productline',
                component: ProductLineComponent

            },
            {
                path: 'partcategory',
                component: PartCategoryComponent

            },
            {
                path: 'partgroup',
                component: PartGroupComponent

            },
            {
                path: 'partgroup/:id',
                component: PartComponent
            },
            {
                path: 'export',
                component: ExportComponent
            },
            {
                path: 'color',
                component: ColorComponent, canDeactivate: [Color]
            }
        ]


    },

];

@NgModule({
    imports: [
    RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload' })
    ],
    exports: [RouterModule]
})

export class OPCAdminModuleRouting {

}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/opc-admin.module.routing.ts